import * as React from 'react'
import { InjectedIntlProps } from 'react-intl'

import Logo from '@uniiverse/library/assets/universe.svg'
import XIcon from '@uniiverse/library/assets/icons/x.svg'

import { Drawer } from 'src/elements/Drawer'
import { signInPath } from 'src/lib/navigate-to'

import { locale } from './locale'

const style = require('./MobileDrawer.css')

interface Props {
  viewer: any; // TODO
  shown: boolean;
  onClose: () => void;
}

export const MobileDrawer: React.FunctionComponent<Props & InjectedIntlProps> = ({
  shown,
  onClose,
  viewer,
  intl,
}) => (
  <Drawer shown={shown} onClose={onClose}>
    <Logo className={style.logo} />
    <XIcon className={style.close} onClick={onClose} />
    {viewer ?
      <React.Fragment>
        {(viewer.host || viewer.memberships.nodes.length > 0) && (
          <React.Fragment>
            <Drawer.Link to="/dashboard" reload>
              {intl.formatMessage(locale.dashboard)}
            </Drawer.Link>
            <Drawer.Link to="/dashboard/my-events" reload>
              {intl.formatMessage(locale.eventsYouAreHosting)}
            </Drawer.Link>
            <Drawer.Separator />
          </React.Fragment>
        )}
        <Drawer.Link to="/dashboard/tickets" reload>
          {intl.formatMessage(locale.myTickets)}
        </Drawer.Link>
        <Drawer.Separator />
        <Drawer.Link to="/explore">
          {intl.formatMessage(locale.findEvents)}
        </Drawer.Link>
        <Drawer.Link to="/create" reload>
          {intl.formatMessage(locale.createEvent)}
        </Drawer.Link>
        <div className={style.bottom}>
          <Drawer.Separator />
          <Drawer.Link to={`/users/${viewer.slug}`} reload>
            {intl.formatMessage(locale.profile)}
          </Drawer.Link>
          <Drawer.Link to="/dashboard/conversations" reload>
            {intl.formatMessage(locale.messages)}
          </Drawer.Link>
          <Drawer.Link to="/dashboard/settings" reload>
            {intl.formatMessage(locale.settings)}
          </Drawer.Link>
          <Drawer.Link to="/help" reload>
            {intl.formatMessage(locale.help)}
          </Drawer.Link>
          <Drawer.Link to="/users/sign_out" reload>
            {intl.formatMessage(locale.logOut)}
          </Drawer.Link>
        </div>
      </React.Fragment>
      :
      <React.Fragment>
        <Drawer.Link to="/explore">
          {intl.formatMessage(locale.findEvents)}
        </Drawer.Link>
        <Drawer.Link to="/create" reload>
          {intl.formatMessage(locale.createEvent)}
        </Drawer.Link>
        <Drawer.Link to="/features" reload>
          {intl.formatMessage(locale.features)}
        </Drawer.Link>
        <Drawer.Link to="/customers" reload>
          {intl.formatMessage(locale.customers)}
        </Drawer.Link>
        <Drawer.Link to="/pricing" reload>
          {intl.formatMessage(locale.pricing)}
        </Drawer.Link>
        <div className={style.bottom}>
          <Drawer.Separator />
          <Drawer.Link to="/help" reload>
            {intl.formatMessage(locale.help)}
          </Drawer.Link>
          <Drawer.Link to={signInPath()} reload skip>
            {intl.formatMessage(locale.logIn)}
          </Drawer.Link>
          <Drawer.Link to="/sign-up" reload>
            {intl.formatMessage(locale.signUp)}
          </Drawer.Link>
        </div>
      </React.Fragment>
    }
  </Drawer>
)
